import React from "react";
import { NavLink } from "react-router-dom";
import CourseNoteCourseTitleValue from "../../../../models/views/education/CourseNoteCourseTitleValue";
import CourseNoteService from "../../../../services/education/CourseNoteService";
import NotFoundDataInDate from "../../../shared/not-found-data-in-date/NotFoundDataInDate";
import { resolveCourseMediaUrl } from "../course-note.data";
import CourseSubjectsState, { CourseSubjectsProps } from "./CourseSubjects.models";
import "./CourseSubjects.scss";

export default class CourseSubjects extends React.PureComponent<CourseSubjectsProps, CourseSubjectsState> {
    courseNoteService: CourseNoteService;

    constructor(props: CourseSubjectsProps) {
        super(props);
        this.courseNoteService = new CourseNoteService();
        this.state = {
            courses: [],
            searchText: "",
        };
    }

    componentDidMount() {
        this.getCourses();
    }

    getCourses = () => {
        const self = this;
        this.courseNoteService.getCourseTitleValues().then(function (response) {
            self.setState({ courses: response ?? [] });
        });
    };

    handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchText: e.target.value });
    };

    getFilteredCourses = (): CourseNoteCourseTitleValue[] => {
        const { courses, searchText } = this.state;
        const query = searchText.trim();
        if (!query) return courses;
        return courses.filter((course) => course.title.includes(query));
    };

    render(): React.ReactNode {
        const { searchText } = this.state;
        const filteredCourses = this.getFilteredCourses();

        return (
            <>
                <div className="search-row">
                    <div className="search-box">
                        <span className="mdi mdi-magnify"></span>
                        <input
                            type="text"
                            value={searchText}
                            onChange={this.handleSearch}
                            placeholder="جستجوی درس..."
                        />
                    </div>
                </div>

                {filteredCourses.length > 0 ? (
                    <div className="courses-grid">
                        {filteredCourses.map((course) => (
                            <div key={course.value} className="course-card-wrapper">
                                <NavLink
                                    to={`/CourseNoteCategories?courseId=${course.value}`}
                                    className="course-card"
                                >
                                    <div className="course-image-wrap">
                                        <img src={resolveCourseMediaUrl(course.imageUrl)} alt={course.title} />
                                    </div>
                                    <label className="course-title">{course.title}</label>
                                </NavLink>
                            </div>
                        ))}
                    </div>
                ) : (
                    <NotFoundDataInDate title="دوره ای برای نمایش وجود ندارد." />
                )}
            </>
        );
    }
}
